import React, { useState, useEffect, useRef } from "react";
import { Table, Modal, Spinner, Alert } from "react-bootstrap";
import { useAlert } from "react-alert";
import { baseUrl } from "../../../../services/config";
import { Paper } from "@material-ui/core";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { PremissionChecker } from "../../../../services/PremissionChecker";
import { useSelector } from "react-redux";
import Pagination from "@material-ui/lab/Pagination";
import usePagination from "../../../../components/usePagination/usePagination";
import { sendTestResultNotifications } from "../../../../components/SendNotifications/SendNotifications";

const HifzExam = () => {
  const user = useSelector((state) => state.user.user);
  const authtoken = localStorage.getItem("userToken");

  const [allSessions, setAllSessions] = useState([]);
  const [campuses, setallcampuses] = useState(user.campuses || []);
  const [selectedCampus, setSelectedCampus] = useState("");
  const [currentSession, setCurrentSession] = useState("");
  const [editExamName, setEditExamName] = useState("");
  const [educationType, setEducationType] = useState(2);

  const [selectedExamType, setSelectedExamType] = useState("");

  const [allClasses, setAllClasses] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");

  const [allSections, setAllSections] = useState([]);
  const [selectedSection, setSelectedSection] = useState("");
  const [currentDate, setCurrentDate] = useState("");
  const [testDetails, setExamDetails] = useState([]);

  const [editExamModal, setEditExamModal] = useState(false);
  const [editExamID, setEditExamID] = useState([]);
  const [editExamType, setEditExamType] = useState("");
  const [editDate, setEditDate] = useState("");

  const [deleteExamModal, setDeleteExamModal] = useState(false);
  const [deleteableExam, setDeleteableExam] = useState("");

  const [loading, setloading] = useState(false);
  //   const [sendLoading, setSendLoading] = useState(false);
  const [isallfields, setisallfields] = useState(false);
  const [editExamLoading, setEditExamLoading] = useState(false);
  const alert = useAlert();
  const [deleteloading, setdeleteloading] = useState(false);

  //   const [selectedTests, setSelectedTests] = useState([]);
  //   const [mainCheckBoxChecked, setmaincheckboxChecked] = useState(false);
  //   const searchClicked = useRef(false);
  //   const firstTimeLoad = useRef(false);

  //   const [sendTestMessageModal, setSendTestMessageModal] = useState(false);
  //   const [notificationModal, setNotificationModal] = useState(false);

  useEffect(() => {
    // if (!firstTimeLoad.current) {
    //   firstTimeLoad.current = true;
    getAllSessions();
    // }

    // if (searchClicked.current) {
    //   searchClicked.current = false;
    //   setAllCheckboxes(true);
    // } else {
    //   checkAllCheckBoxes();
    // }
    //   }, [[], selectedTests]);
  }, []);

  const getAllSessions = () => {
    fetch(`${baseUrl}/session`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setAllSessions([...data.payload]);
        data.payload.forEach((session, index) => {
          if (session.active_academic_year == "1") {
            setCurrentSession(session.id);
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onCampusChange = async (id) => {
    setSelectedCampus(id);
    getCampusClasses(id);
    setAllClasses([]);
    setSelectedClass("");
    setAllSections([]);
    setSelectedSection("");
  };

  const getCampusClasses = (id) => {
    fetch(`${baseUrl}/campusclass/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.payload) {
          setAllClasses(data.payload);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onClassChange = (id) => {
    setSelectedClass(id);
    setAllSections([]);
    setSelectedSection("");

    fetch(`${baseUrl}/class_section/${selectedCampus}/${educationType}/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setAllSections([...data.payload]);
      })
      .catch((err) => {
        console.log("section error", err);
      });
  };

  // Main functions
  const getExamResult = () => {
    setExamDetails([]);
    setloading(true);

    fetch(
      `${baseUrl}/hifz-exams/${currentSession != "" ? currentSession : null}/${
        selectedCampus != "" ? selectedCampus : null
      }/${selectedClass != "" ? selectedClass : null}/${
        selectedSection != "" ? selectedSection : null
      }/${selectedExamType != "" ? selectedExamType : null}/${
        currentDate != "" ? currentDate : null
      }`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${authtoken}`,
        },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata.success) {
          setloading(false);
          let res = data.payload;
          let temparr = res;
          res.map((item, index) => {
            item["SrNo"] = index + 1;
            temparr[index] = item;
          });
          setExamDetails(temparr);
        } else if (!data.metadata.success) {
          alert.error(data.metadata.message);
          setloading(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  //   const sendNoticationModal = () => {
  //     if (selectedTests == "") {
  //       return alert.error("Please Select Some Students");
  //     }
  //     setNotificationModal(true);
  //   };

  //   const sendNotification = () => {
  //     setSendLoading(true);
  //     if (selectedTests.length > 0) {
  //       // console.log(selectedTests);
  //       let FinalNotificationArray = [];
  //       const res = testDetails.filter((item) =>
  //         selectedTests.includes(item?.id)
  //       );
  //       console.log(res, "after filter");
  //       res.forEach((result) => {
  //         result.test_results.forEach((resultItem) => {
  //           // Ensure required properties exist to avoid errors
  //           if (resultItem.student && result.test_type && result.subject) {
  //             FinalNotificationArray.push({
  //               title: "Daily Test",
  //               description: `Dear Parents/Guardian, ${resultItem.student.name} (${resultItem.student.admission_id}) ${result.test_type.name} Test Result is: ${result.subject.slug} ${resultItem.gain_marks}/${result.full_marks} (${result.date})`,
  //               id: resultItem.student.notification_id,
  //             });
  //           } else {
  //             console.warn("Skipping invalid result item:", resultItem);
  //           }
  //         });
  //       });
  //       // console.log(FinalNotificationArray, "finnaly");
  //       sendTestResultNotifications(FinalNotificationArray);
  //       setSendLoading(false);
  //       alert.success("Notification Successfully Sent");
  //       setAllCheckboxes(false);
  //       setNotificationModal(false);
  //     } else {
  //       setSendLoading(false);
  //       alert.error("Please select at least one student");
  //       setNotificationModal(false);
  //     }
  //   };

  //   const sendTestModal = () => {
  //     if (selectedTests == "") {
  //       return alert.error("Please Select Some Students");
  //     }
  //     setSendTestMessageModal(true);
  //   };

  //   const sendBulkTestSMS = () => {
  //     if (selectedTests == "") {
  //       return alert.error("Please Select Some Tests");
  //     }

  //     setSendLoading(true);
  //     let data = {
  //       test_ids: selectedTests,
  //     };

  //     fetch(`${baseUrl}/multiple-tests-send-sms`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${authtoken}`,
  //       },
  //       body: JSON.stringify(data),
  //     })
  //       .then((res) => res.json())
  //       .then((data) => {
  //         if (data.metadata.success) {
  //           alert.success("Test Message Sent Successfully");
  //           setSendLoading(false);
  //           setSendTestMessageModal(false);
  //         } else if (!data.metadata.success) {
  //           alert.error(data.metadata.message);
  //           setSendLoading(false);
  //           setSendTestMessageModal(false);
  //         }
  //       })
  //       .catch((err) => {
  //         setSendLoading(false);
  //         setSendTestMessageModal(false);
  //         console.log(err);
  //       });
  //   };

  // Handle Test Checkbox

  //   const handleMainCheckboxClick = () => {
  //     if (mainCheckBoxChecked) setAllCheckboxes(false);
  //     else setAllCheckboxes(true);
  //   };

  //   const setAllCheckboxes = (value) => {
  //     setmaincheckboxChecked(value);
  //     if (value) {
  //       setSelectedTests([]);
  //     }

  //     testDetails.map((item, i) => {
  //       item.checked = value;
  //       if (!value) {
  //         RemoveSelectedTest(item);
  //       } else {
  //         AddSelectedTest(item);
  //       }
  //     });
  //   };

  //   const checkAllCheckBoxes = () => {
  //     if (testDetails.length == selectedTests.length) {
  //       setmaincheckboxChecked(true);
  //     } else if (mainCheckBoxChecked) {
  //       setmaincheckboxChecked(false);
  //     }
  //   };

  //   const handleChallansCheckBoxClick = (e, index) => {
  //     testDetails.map((item, i) => {
  //       if (item.id == index) {
  //         item.checked = !item.checked;

  //         if (item.checked) {
  //           AddSelectedTest(item);
  //         } else {
  //           RemoveSelectedTest(item);
  //         }
  //       }
  //     });
  //   };

  //   const AddSelectedTest = (item) => {
  //     setSelectedTests((prevSelectedTests) => [...prevSelectedTests, item.id]);
  //   };

  //   const RemoveSelectedTest = (item) => {
  //     setSelectedTests((prevSelectedTests) =>
  //       prevSelectedTests.filter((id) => id !== item.id)
  //     );
  //   };

  // Handle Update and Delete Tests
  const getEditExam = async (id) => {
    await fetch(`${baseUrl}/hifz-exams/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setEditExamType(data.payload[0]?.type);
          setEditExamName(data.payload[0]?.name);
          setEditDate(data.payload[0]?.date);
        });
      })
      .catch((err) => {
        alert.error(err);
        setloading(false);
      });
  };

  const updateExamHandler = async () => {
    if (editExamType == "" || editExamName == "" || editDate == "") {
      setisallfields(true);
      return;
    }
    setEditExamLoading(true);
    setisallfields(false);
    const data = {
      type: editExamType,
      name: editExamName,
      date: editDate,
    };

    await fetch(`${baseUrl}/hifz-exams/${editExamID}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) =>
        res.json().then((data) => {
          if (data.metadata.success) {
            setEditExamLoading(false);
            setEditExamModal(false);
            alert.success("Exam successfully Updated");
            getExamResult();
          } else if (!data.metadata.success) {
            alert.error(data.metadata.message);
            setEditExamLoading(false);
            setEditExamModal(false);
          } else {
            alert.show("Something Went Wrong");
            setEditExamLoading(false);
            setEditExamModal(false);
          }
        })
      )
      .catch((err) => {
        setEditExamLoading(false);
        setEditExamModal(false);
        console.log(err);
      });
  };

  const deleteExamHandle = async () => {
    setdeleteloading(true);

    await fetch(`${baseUrl}/hifz-exams/${deleteableExam}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          if (data.metadata.success) {
            alert.success(data.metadata.message);
            getExamResult();
            setdeleteloading(false);
            setDeleteExamModal(false);
          } else if (!data.metadata.success) {
            alert.error(data.metadata.message);
            setdeleteloading(false);
            setDeleteExamModal(false);
          }
        } else {
          alert.show("Something Went Wrong");
          setdeleteloading(false);
          setDeleteExamModal(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setdeleteloading(false);
        setDeleteExamModal(false);
      });
  };

  // Variables & Function For Pagination
  let [page, setPage] = useState(1);
  const PER_PAGE = 10;

  const count = Math.ceil(testDetails.length / PER_PAGE);
  const _DATA = usePagination(testDetails, PER_PAGE);

  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };

  return (
    <div>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        <div className="row mt-5">
          <div className="col-md-3">
            <label>
              <b>Select Session</b>
              <span style={{ color: "red", fontSize: 12 }}>*</span>
            </label>
            <select
              onChange={(e) => setCurrentSession(e.target.value)}
              className="form-select h-40px"
              value={currentSession}
              aria-label="Default select example"
            >
              <option value="">Select Session</option>
              {allSessions.map((session, index) => (
                <option key={index} value={session.id}>
                  {session.year}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label>
              <b>Select Campus</b>
              <span style={{ color: "red", fontSize: 12 }}>*</span>
            </label>
            <select
              className="form-select h-40px"
              name="campus_id"
              value={selectedCampus}
              onChange={(e) => onCampusChange(e.target.value)}
              aria-label="Default select example"
            >
              <option value="">Select Campus</option>
              {campuses.map((campus, index) => (
                <option key={index} value={campus.id}>
                  {campus.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label>
              <b>Select Class</b>
              <span style={{ color: "red", fontSize: 12 }}>*</span>
            </label>
            <select
              className="form-select h-40px"
              name="class_id"
              value={selectedClass}
              onChange={(e) => onClassChange(e.target.value)}
              aria-label="Default select example"
            >
              <option value="">Select Class</option>
              {allClasses.map((campus, index) => (
                <option key={index} value={campus.id}>
                  {campus.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label>
              <b>Select Education Type</b>
              <span style={{ color: "red", fontSize: 12 }}>*</span>
            </label>
            <select
              className="form-select h-40px"
              name="campus_id"
              value={educationType}
              aria-label="Default select example"
              onChange={(e) => {
                setEducationType(e.target.value);
              }}
              disabled
            >
              <option value={1}>Education</option>
              <option value={2}>Hifz</option>
            </select>
          </div>
        </div>

        <div className="row mt-3 mb-5">
          <div className="col-md-3">
            <label>
              <b>Select Section</b>
              <span style={{ color: "red", fontSize: 12 }}>*</span>
            </label>

            <select
              className="form-select h-40px"
              name="section_id"
              value={selectedSection}
              onChange={(e) => setSelectedSection(e.target.value)}
              aria-label="Default select example"
            >
              <option value="">Select Section</option>
              {allSections.map((sec, index) => (
                <option key={index} value={sec.id}>
                  {sec.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label>
              <b>Select Exam Type</b>
              <span style={{ color: "red", fontSize: 12 }}>*</span>
            </label>
            <select
              onChange={(e) => {
                setSelectedExamType(e.target.value);
              }}
              className="form-select h-40px"
              value={selectedExamType}
              aria-label="Default select example"
            >
              <option value="">Select Exam Type</option>
              <option value={"Annual"}>Annual</option>
              <option value={"Monthly"}>Monthly</option>
            </select>
          </div>

          <div className="col-md-3">
            <label>
              <b>
                Select Date{" "}
                <span style={{ color: "red", fontSize: 12 }}>*</span>
              </b>
            </label>
            <input
              value={currentDate}
              className="form-control"
              onChange={(e) => setCurrentDate(e.target.value)}
              type="date"
            />
          </div>
        </div>

        <div className="d-flex mt-5">
          <button className="btn btn-primary w-205px" onClick={getExamResult}>
            Get All Exam
          </button>

          {testDetails.length > 0 && (
            <>
              {/* <button
                className="btn btn-primary w-205px mx-2"
                onClick={sendTestModal}
                disabled={sendLoading ? true : false}
              >
                {sendLoading ? "Sending..." : "Send Test SMS"}
              </button>

              <button
                className="btn btn-primary w-205px mx-2"
                onClick={sendNoticationModal}
              >
                Send Test Notifications
              </button> */}
            </>
          )}
        </div>

        <div className="mt-5">
          <Table responsive>
            <thead>
              <tr>
                {/* <th style={{ width: "5px" }}>
                  <label className="checkbox checkbox-single">
                    <input
                      type="checkbox"
                      className="form-checkbox"
                      onClick={(e) => {
                        handleMainCheckboxClick();
                      }}
                      checked={mainCheckBoxChecked}
                      readOnly
                    />
                    <span />
                  </label>
                </th> */}
                <th className="text-center">Sr.No</th>
                <th className="text-center">Exam Name</th>
                <th className="text-center">Exam Type</th>
                <th className="text-center">Campus Name</th>
                <th className="text-center">Class Name</th>
                <th className="text-center">Section Name</th>
                <th className="text-center">Total Marks</th>
                <th className="text-center">Date</th>
                <th className="text-center">Edit</th>
                <th className="text-center">Delete</th>
              </tr>
            </thead>
            <tbody>
              {_DATA.currentData().map((examList, index) => (
                <tr key={index}>
                  {/* <td style={{ width: "5px" }}>
                    <label className="checkbox checkbox-single">
                      <input
                        type="checkbox"
                        className="form-checkbox"
                        value={testList.id}
                        key={testList.id}
                        onClick={(e) => {
                          handleChallansCheckBoxClick(e, testList.id);
                        }}
                        checked={testList.checked ?? false}
                        readOnly
                      />
                      <span />
                    </label>
                  </td> */}
                  <td className="text-center">{examList?.SrNo}</td>
                  <td className="text-center">{examList?.name}</td>
                  <td className="text-center">{examList?.type}</td>
                  <td className="text-center">{examList?.campus?.name}</td>
                  <td className="text-center">
                    {examList?.student_class?.name}
                  </td>
                  <td className="text-center">
                    {examList?.global_section?.name}
                  </td>
                  <td className="text-center">{examList?.total_marks}</td>
                  <td className="text-center">{examList?.date}</td>

                  <td className="text-center">
                    <a
                      className={
                        "btn btn-icon btn-light btn-hover-primary-custom btn-sm mx-3"
                      }
                      onClick={() => {
                        getEditExam(examList?.id);
                        setEditExamID(examList?.id);
                        setEditExamModal(true);
                      }}
                    >
                      <span className="svg-icon svg-icon-md svg-icon-primary-custom ">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Write.svg"
                          )}
                        />
                      </span>
                    </a>
                  </td>
                  <td className="text-center">
                    <a
                      className={
                        "btn btn-icon btn-light btn-hover-primary-custom btn-sm mx-3"
                      }
                      onClick={() => {
                        setDeleteableExam(examList?.id);
                        setDeleteExamModal(true);
                      }}
                    >
                      <span className="svg-icon svg-icon-md svg-icon-danger">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Delete-user.svg"
                          )}
                        />
                      </span>
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          <div className="row justify-content-center">
            {loading && (
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            )}
          </div>

          <Pagination
            color="text-primary"
            count={count}
            size="large"
            page={page}
            variant="text"
            shape="round"
            onChange={handleChange}
          />
        </div>

        {/* ------------------------Hifz Exam Start----------------------- */}

        {/* Update Hifz Exam */}
        <Modal show={editExamModal} size="lg">
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Update Exam
            </Modal.Title>
          </Modal.Header>

          {editExamLoading ? (
            <div style={{ padding: "20px" }}>
              {" "}
              <b style={{ color: "green" }}>
                {" "}
                Exam Updating Please Wait...{" "}
                <span className="spinner-borderd"></span>
              </b>
            </div>
          ) : (
            <Modal.Body>
              <div className="row">
                <div className="col-md-4">
                  <label>
                    <b>Enter Exam Name</b>
                    <span style={{ color: "red", fontSize: 12 }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={editExamName}
                    onChange={(e) => setEditExamName(e.target.value)}
                    name="total_marks"
                    placeholder="Enter Exam Name"
                  />
                </div>

                <div className="col-md-4">
                  <label>
                    <b>Select Exam Type</b>
                    <span style={{ color: "red", fontSize: 12 }}>*</span>
                  </label>
                  <select
                    onChange={(e) => {
                      setEditExamType(e.target.value);
                    }}
                    className="form-select h-40px"
                    value={editExamType}
                    aria-label="Default select example"
                  >
                    <option value="">Select Exam Type</option>
                    <option value={"Annual"}>Annual</option>
                    <option value={"Monthly"}>Monthly</option>
                  </select>
                </div>

                <div className="col-md-4">
                  <label>
                    <b>
                      Select Date{" "}
                      <span style={{ color: "red", fontSize: 12 }}>*</span>
                    </b>
                  </label>
                  <input
                    value={editDate}
                    className="form-control"
                    onChange={(e) => setEditDate(e.target.value)}
                    type="date"
                  />
                </div>
              </div>

              <br />
              <br />
              {isallfields ? (
                <>
                  <Alert
                    variant="danger"
                    onClose={() => setisallfields(false)}
                    dismissible
                  >
                    <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
                    <p>Please fill or select all fields</p>
                  </Alert>
                </>
              ) : null}
            </Modal.Body>
          )}

          <Modal.Footer>
            <button
              className="btn btn-primary"
              onClick={updateExamHandler}
              disabled={editExamLoading ? true : false}
            >
              Update Exam
            </button>
            <button
              className="btn btn-danger btn_width"
              onClick={() => {
                setEditExamModal(false);
                setisallfields(false);
              }}
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>

        {/* Delete Hifz Exam */}
        <Modal show={deleteExamModal}>
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Are you sure want to delete this exam?
            </Modal.Title>
          </Modal.Header>
          {deleteloading ? (
            <div style={{ padding: "20px" }}>
              {" "}
              <b style={{ color: "green" }}>
                {" "}
                Exam Deleting Please Wait{" "}
                <span className="spinner-borderd"></span>
              </b>
            </div>
          ) : (
            <Modal.Footer>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <button onClick={deleteExamHandle} className="btn button_blue">
                  Delete
                </button>
                <button
                  style={{ marginLeft: "10px" }}
                  onClick={() => setDeleteExamModal(false)}
                  className="btn btn-danger btn_width"
                >
                  Cancel
                </button>
              </div>
            </Modal.Footer>
          )}
        </Modal>
        {/* ------------------------Hifz Exam End----------------------- */}

        {/* Comfirmation SMS Modal Start*/}
        {/* <Modal show={sendTestMessageModal}>
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Are you sure want to send test result message?
            </Modal.Title>
          </Modal.Header>
          {sendLoading ? (
            <div style={{ padding: "20px" }}>
              {" "}
              <b style={{ color: "green" }}>
                {" "}
                Message Sending Please Wait...{" "}
                <span className="spinner-borderd"></span>
              </b>
            </div>
          ) : (
            <Modal.Footer>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <button
                  onClick={sendBulkTestSMS}
                  className="btn button_blue"
                  disabled={sendLoading ? true : false}
                >
                  {sendLoading ? "Sending..." : "Send"}
                </button>
                <button
                  style={{ marginLeft: "10px" }}
                  onClick={() => setSendTestMessageModal(false)}
                  className="btn btn-danger btn_width"
                >
                  Cancel
                </button>
              </div>
            </Modal.Footer>
          )}
        </Modal> */}
        {/* ------------------------Comfirmation SMS Modal End----------------------- */}

        {/* Comfirmation Notification Modal Start*/}
        {/* <Modal show={notificationModal}>
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Are you sure want to send test result notification?
            </Modal.Title>
          </Modal.Header>
          {sendLoading ? (
            <div style={{ padding: "20px" }}>
              {" "}
              <b style={{ color: "green" }}>
                {" "}
                Message Sending Please Wait...{" "}
                <span className="spinner-borderd"></span>
              </b>
            </div>
          ) : (
            <Modal.Footer>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <button onClick={sendNotification} className="btn button_blue">
                  {sendLoading ? "Sending..." : "Send"}
                </button>
                <button
                  style={{ marginLeft: "10px" }}
                  onClick={() => setNotificationModal(false)}
                  className="btn btn-danger btn_width"
                >
                  Cancel
                </button>
              </div>
            </Modal.Footer>
          )}
        </Modal> */}
        {/* Comfirmation Notification Modal End */}
      </Paper>
    </div>
  );
};

export default HifzExam;
